
<div *ngIf="safePdfUrl" class="pdf-viewer">
    <iframe [src]="safePdfUrl" width="100%" height="100%"></iframe>
    <button class="close-btn" (click)="closePdf()">Close</button>
  </div>
  
